export const TYPE_OPTIONS = [
  { label: "All", value: "0" },
  { label: "Monthly Fee", value: "3" },
  { label: "Top Up", value: "5" },
  { label: "Debit Payment", value: "4" },
  { label: "Outgoing Payment", value: "2" },
  { label: "Incoming Payment", value: "1" },
]
